import { useQuery } from "@tanstack/react-query";
import { roleApi } from "../services/role.api";
import { TRoleFilter } from "../../../interfaces/roleInterface";
import { IApiPagination } from "../../../interfaces/IPagination";

export type UseRolesQueryParams = {
  filter: TRoleFilter;
  pagination: IApiPagination;
};

export const useRolesQuery = (params: UseRolesQueryParams) => {
  return useQuery({
    queryKey: ["roles", params],
    queryFn: async () => {
      const res = await roleApi.getRoles(params.filter, params.pagination);
      return res.data;
    },
    staleTime: 1000 * 60, // 1 minute
  });
};

export const useRoleByIdQuery = (roleId?: string) => {
  return useQuery({
    queryKey: ["role-by-id", roleId],
    queryFn: () => roleApi.getRoleById(roleId as string),
    staleTime: 1000 * 60, // 1 minute
    enabled: !!roleId,
  });
};
